<style scoped>
@media (max-width: 590px) {
  .card {
    margin: 1rem auto !important;
  }
}
</style>

<template>
  <b-card
    :no-body="noBody"
    :img-src="card.img"
    :img-alt="card.value"
    img-top
    v-bind:bg-variant="getCardBgVariant(selectedValue)"
    style="max-width: 10rem;"
    class="img-padding m-3 card text-center"
    v-on:click="onClick"
    v-bind:class="{'card-active' : isCardSelected(selectedValue)}">
      <b-card-body v-if="card.description">
        {{ card.description }}
      </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    card: Object,
    selectedValue: String,
  },
  computed: {
    noBody() {
      const description = this.card.description;
      return description === undefined || description === null || description === '';
    },
  },
  methods: {
    onClick() {
      this.$emit('cardSelected');
    },
    isCardSelected(selectedValue) {
      return this.card.value === selectedValue;
    },
    getCardBgVariant(selectedValue) {
      if (this.isCardSelected(selectedValue)) {
        return 'light';
      }
      return '';
    },
  },
};
</script>

<style scoped>
    .img-padding {
        padding: 1px;
    }

    .card {
      cursor: pointer;
    }

    .card:hover, .card-active{
      border-width: 3px;
      border-color: #3e88c9;
    }
</style>



// WEBPACK FOOTER //
// src/components/utils/Card.vue